import React, { useContext, useEffect } from 'react';

import { externalLinkEnvUrl, switchENV } from '../../shared/Links';
import TransferContext from '../../../containers/TransferContainer/context';
import PageWrapper from '../../PageWrapper/PageWrapper';
import DashboardIcon from '../../../images/Dashboard.svg';
import OTTIcon from '../../../images/OneTimeTrade.svg';
import planningDetailsIcon from '../../../images/PlanningDetails.svg';
import './ConfirmationHub.scss';

const confirmationContent = [
  {
    id: 'one-time-trade-link',
    image: OTTIcon,
    // @To Do - update once the link is active
    redirectURL: `${switchENV(
      externalLinkEnvUrl
    )}/usis/advice/checkout/transfer`,
    linkText: 'Make Another Transfer',
    linkDescription: 'Transfer another account to the Retirement Advisory Service accounts.'
  },
  {
    id: 'planning-details-link',
    image: planningDetailsIcon,
    redirectURL: `${switchENV(
      externalLinkEnvUrl
    )}/usis/my-accounts/planning-details`,
    linkText: 'View Planning Details',
    linkDescription: 'Take a look at your overall planning details and check out our simulation tools as well.'
  },
  {
    id: 'dashboard-link',
    image: DashboardIcon,
    redirectURL: `${switchENV(
      externalLinkEnvUrl
    )}/usis/my-accounts/dashboard`,
    linkText: 'View Your Dashboard',
    linkDescription: 'Review your portfolio and track how your investments are performing.'
  }
];

const OptionContainer = ({ imgId, linkId, descId, alt, redirectURL, linkIcon, linkText, linkDescription}) =>
  (
      <a href={redirectURL} id={linkId} className="optionsLink">
          <div className="optionsImageContainer">
              <img
                  src={linkIcon}
                  className="optionsImage"
                  alt={alt}
                  id={imgId} />
          </div>
          <div
              className="optionsLinkText">
              {linkText}
          </div>
          <div id={descId} className="optionsLinkDescription">
              {linkDescription}
          </div>
      </a>
  );

const ConfirmationHub = () => {
    const { state } = useContext(TransferContext);
    const { submitted } = state;

    if (!submitted) {
        window.location.replace('/usis/my-accounts/dashboard');
    }

    useEffect(() => {
        const clientMetrics = document.createElement('script');
        clientMetrics.type='text/javascript';
        clientMetrics.innerHTML=`
            window.metricsData.ras = window.metricsData.ras || {};
            window.metricsData.ras.engagementType = 'RAS-Undetermined/Add Cash';
        `
        document.body.appendChild(clientMetrics);

        if (document.querySelector('body') && document.querySelector('body').scrollTop) {
            document.querySelector('body').scrollTop = 0;
        }
    }, []);

    return (
        <>
            <PageWrapper classes='transfer-container-wrapper' bgColor='#FFFFFF'>
                <div className="optionsHeader">
                    What&apos;s next?
                </div>
                <div className='cardActionContainer'>
                    {confirmationContent.map(e =>
                        <OptionContainer
                            alt={e.id}
                            linkId={`${e.id}-text`}
                            descId={`${e.id}-sub-text`}
                            imgId={`${e.id}-image`}
                            linkText={e.linkText}
                            linkIcon={e.image}
                            linkDescription={e.linkDescription}
                            redirectURL={e.redirectURL}
                        />
                    )}
                </div>
            </PageWrapper>
        </>
    );
};

export default ConfirmationHub;
